import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.pages.rental-benefit-selection.title',
    defaultMessage: 'What would you like to do?',
  },
  confirmBenefitSelection: {
    id: 'app.pages.rental-benefit-selection.confirm',
    defaultMessage: 'Confirm',
  },
  replacementCar: {
    id: 'app.pages.rental-benefit-selection.benefit.replacement-car',
    defaultMessage: 'I need a replacement car until my car is repaired',
  },
  returnHome: {
    id: 'app.pages.rental-benefit-selection.benefit.return-home',
    defaultMessage: 'I need to return to my home location',
  },
  reachOriginalDestination: {
    id: 'app.pages.rental-benefit-selection.benefit.reach-original-destination',
    defaultMessage: 'I need to reach my original destination',
  },
  other: {
    id: 'app.pages.rental-benefit-selection.benefit.other',
    defaultMessage: 'Other',
  },
});
